import React, { useEffect, useRef, useState } from 'react';
import CompanyIcon from '../../../assests/img/company-icon.svg?react';
import DistributionIcon from '../../../assests/img/distribution.png?url';
import DropdownIcon from '../../../assests/img/dropdown.svg?react';
import {captializeText} from '../functions/utils';
import '../../../assests/css/infotype.scss';


export interface infoTypeProps {
    type: string,
    field: 'distribution' | 'type',
    showDropdown: boolean,
    onUpdate?: (selected: string)=> Promise<void>,
}

export default function InfoType(props: infoTypeProps) {

    const {type, field, showDropdown, onUpdate} = props;

    const dropdownRef = useRef<HTMLDivElement>(null);
    const [showSelect, setShowSelect] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClickOutside=(event: MouseEvent)=> {
        if (dropdownRef.current &&
            !dropdownRef.current.contains(event.target as Node)) {
            setShowSelect(false);
        }
    }

    const handleShowSelect = () => {
        if (showSelect) {
            setShowSelect(false);
        } else {
            setShowSelect(true);
        }
    }

    const getOptionText = () => {
        if (field === 'distribution') {
            if (type.toLowerCase() === 'direct') {
                return 'Wholesale';
            } else {
                return 'Direct';
            }
        } else if (field === 'type') {
            if (type.toLowerCase() === 'carrier') {
                return 'Wholesaler';
            } else {
                return 'Carrier';
            }
        }
        return type;
    }

    const handleUpdate = async (selected: string) => {
        setLoading(true);
        setShowSelect(false);
        if (onUpdate) {
            await onUpdate(selected);
        }
        setLoading(false);
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [
    ]);

    return (
        <div className="info-type-container">
            <div className="info-type-content">
                <span>
                    {type.toLowerCase() === 'carrier' || type.toLowerCase() === 'wholesaler'?
                        <CompanyIcon width={16}/>:
                            field === 'distribution'? <img src={DistributionIcon}
                                width={'14px'}/>: <CompanyIcon width={16}/>}
                </span>
                <span className="info-type-text">
                    {captializeText(props.type)}
                </span>
                {showDropdown?
                <>
                    <div className="info-type-dropdown"
                        onClick={handleShowSelect}>
                       {loading? <span className="edit-loader"/>: <DropdownIcon/>}
                    </div>
                    {showSelect?
                        <div className="info-type-options-container" ref={dropdownRef}>
                            <span className="info-type-options">
                                    <span className="info-type-option"
                                        onClick={()=>
                                            handleUpdate(getOptionText())}>
                                        {captializeText(getOptionText())}
                                    </span>
                            </span>
                        </div>: null}
                </>: null}
            </div>
           
        </div>
    );
}